import { createContext, Dispatch, ReactElement, SetStateAction, useState } from 'react'
import { IUserAuthData } from '../../interfaces/IUserAuthData'

const defaultValue: IUserAuthData = {
  code: null,
  xGuestKey: null,
  callbackUrl: null,
  userId: null,
  isPasswordCorrect: false,
  loginType: 'email',
  registrationCode: '',
  isPasswordNeedToChange: false,
}

export const AuthUserDataContext = createContext<{
  authUserData: IUserAuthData
  setAuthUserData: Dispatch<SetStateAction<IUserAuthData>>
}>({
  authUserData: defaultValue,
  // eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
  setAuthUserData: () => {},
})

interface IAuthUserDataContextProvider {
  children: ReactElement
}

export const AuthUserDataContextProvider = ({ children }: IAuthUserDataContextProvider) => {
  const [authUserData, setAuthUserData] = useState<IUserAuthData>(defaultValue)

  return (
    <AuthUserDataContext.Provider value={{ authUserData, setAuthUserData }}>{children}</AuthUserDataContext.Provider>
  )
}
